import * as React from 'react';
import { classes, style } from 'typestyle';
import { Black, Blue, colorToRgba, GrayCream, Night, White } from '../../../styles/colors';
export default class Tab extends React.Component {
    render() {
        const { children, className, white } = this.props;
        return (React.createElement("div", { className: classes('ta-tab-container', tabContainerStyle, white ? tabContainerWhiteStyle : tabContainerDefaultStyle) },
            React.createElement("div", { className: classes('ta-tab', tabStyle, className) }, children)));
    }
}
const tabContainerStyle = style({
    padding: '4px',
    borderRadius: 16,
});
const tabContainerDefaultStyle = style({
    backgroundColor: Black,
    $nest: {
        '& .ta-tab-button': {
            backgroundColor: colorToRgba(Night, 0.8),
            color: White,
        },
    },
});
const tabContainerWhiteStyle = style({
    backgroundColor: White,
    $nest: {
        '& .ta-tab-button': {
            backgroundColor: GrayCream,
            color: Black,
        },
    },
});
const tabStyle = style({
    display: 'flex',
    borderRadius: '12px',
    whiteSpace: 'nowrap',
    $nest: {
        '& .ta-tab-button:not(:first-child)': {
            marginLeft: '4px',
        },
        '& .ta-tab-button-selected': {
            backgroundColor: Blue,
            color: White,
        },
    },
});
//# sourceMappingURL=Tab.js.map